var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3333C11.2636 13.3333 10.6667 13.9303 10.6667 14.6667C10.6667 15.403 11.2636 16 12 16H20C20.7364 16 21.3333 15.403 21.3333 14.6667C21.3333 13.9303 20.7364 13.3333 20 13.3333H12Z",
    fill: "#00182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 20C10.6667 19.2636 11.2636 18.6667 12 18.6667H20C20.7364 18.6667 21.3333 19.2636 21.3333 20C21.3333 20.7364 20.7364 21.3333 20 21.3333H12C11.2636 21.3333 10.6667 20.7364 10.6667 20Z",
    fill: "#00182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.6667C14.8061 10.6667 16 9.47276 16 8C16 6.52724 14.8061 5.33333 13.3333 5.33333C11.8606 5.33333 10.6667 6.52724 10.6667 8C10.6667 9.47276 11.8606 10.6667 13.3333 10.6667Z",
    fill: "#00182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 0C5.93029 0 5.33333 0.596954 5.33333 1.33333V5.33333H1.33333C0.596954 5.33333 0 5.93029 0 6.66667V22.6667C0 24.8758 1.79086 26.6667 4 26.6667H22.6667C24.8758 26.6667 26.6667 24.8758 26.6667 22.6667V1.33333C26.6667 0.596954 26.0697 0 25.3333 0H6.66667ZM2.66667 8H5.33333V22.6667C5.33333 23.403 4.73638 24 4 24C3.26362 24 2.66667 23.403 2.66667 22.6667V8ZM22.6667 24H7.77239C7.91979 23.583 8 23.1342 8 22.6667V2.66667H24V22.6667C24 23.403 23.403 24 22.6667 24Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsroom);
export default __webpack_public_path__ + "static/media/newsroom.6fd83d42db2c0fd97d46e2f59a4ee920.svg";
export { ForwardRef as ReactComponent };